import Tidal from '../../pages-dynamic/info/tidal/buyer-rental-agreement';
import BotMart from '../../pages-dynamic/info/botmart/buyer-rental-agreement';

export default process.env.WHITE_LABEL_ORG === 'botmart' ? BotMart : Tidal;
